<template>
  <div class="datalist">
    <div style="width:100%;">
      <div class="datalist__header">
        <h3 class="datalist__title">Listes de données</h3>
        <button type="button" class="datalist__button add" @click="createNewList">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Créer une liste de données
        </button>
      </div>
      <DataListItem
          v-for="list of dataLists"
          :key="list._id"
          :title="list.title"
          :dataLists="list.values"
          :_id="list._id"
          @get-data-list="getDataLists"
      />
    </div>
  </div>
</template>

<script>
import DataListItem from "@/components/DataListItem";

export default {
  components: {DataListItem},
  props: {
    _id: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dataLists: [],
      dataListsFields: {
        label: '',
        value: '',
        metadata: {},
      },
      selectedItemIds: [],
    }
  },
  methods: {
    async createNewList() {
      const {value : name } = await this.$swal({
        title: "Entrez le nom de la nouvelle liste",
        input: "text",
        inputPlaceholder: "Nom de la liste",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Veuillez entrer un nom";
          }
        },
      })
      if (name) {
        const result = await this.$axios.post("/api/v2/data-list/save", {
          title: name,
          operationId: this.$route.params._id,
          values: []
        })
        if (result.status === 200) {
          await this.getDataLists()
        }
      }
    },
    async getDataLists () {
      try {
        const response = await this.$axios.get(`/api/v2/data-list/${this.$route.params._id}`);
        this.dataLists = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getDataLists()
  },
}
</script>

<style scoped lang="scss">
.datalist {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.datalist__button {
  padding: 5px 15px;
  background: transparent;
  border: 2px solid #6462f2;
  border-radius: 5px;
  color: #6462f2;
  font-weight: bold;
  transition: all 0.3s ease;

  &.add {
    border-color: green;
    color: green;
  }

  &.delete {
    border-color: red;
    color: red;
  }

  &:disabled {
    background: #ccc;
    filter: saturate(0);
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>